<app-main-contents>
    <h1 class="c-texts--head1">{{ title }}</h1>
    <h2 class="c-texts--head2 h-margin--b24">補足事項があればご記入ください。</h2>
    <app-quotation-remarks [value]="remarks" (changeValue)="remarks=$event"></app-quotation-remarks>
    <app-under-btn-disp [actionButtons]="actionButtons"></app-under-btn-disp>
  </app-main-contents>
  